import { isEmpty, isObject, isString, mapValues } from 'lodash-es';

import { isPresent } from './is-present';

/**
 * Normalizes a record (or array of records) by attempting to JSON-parse each
 * string-valued field. Non-string fields are returned as-is.
 *
 * Empty inputs (`{}` / `[]`) collapse to `null`.
 *
 * NB: parsing is shallow — only top-level fields of each object are inspected.
 */
export function objectNormalize(value: object[] | object): object[] | object | null {
	if (Array.isArray(value))
		return value.map(objectNormalize).filter(isPresent);

	if (isEmpty(value))
		return null;

	if (isObject(value))
		return mapValues(value, tryParseJson);

	return value;
}

function tryParseJson(value: unknown): unknown {
	if (!isString(value))
		return value;

	try {
		return <object>JSON.parse(value);
	} catch {
		return value;
	}
}
